import { Component, h, Prop, State, Watch, Host } from '@stencil/core';
import { Item } from './item';

@Component({
  tag: 'lilu-breadcrumb',
  styleUrl: 'lilu-breadcrumb.scss',
  shadow: true,
})
export class LiluBreadCrumb {
  @Prop() items: string;
  @Prop() color = 'nero';
  @State() internalItems: Item[] = [];

  public lastElement = false;

  componentWillLoad() {
    this.parseColors();
  }

  @Watch('items')
  parseColors() {
    if (this.items !== undefined) {
      this.internalItems = JSON.parse(this.items);
    }
  }

  render() {
    return (
      <Host>
        <ul class="items">
          {this.internalItems.map((item, index) =>
            index + 1 !== this.internalItems.length
              ? item.url && item.name ? [
                  <li class={`item ${this.color}`}>
                    <a class="link" href={item?.url}>
                      <span class="arrow-left"></span>
                      <span class="text">{item.name}</span>
                      <span class="arrow-right"></span>
                    </a>
                  </li>,
                ] : ''
              : [
                <li class={`item ${this.color}`}>
                  <span>{item.name}</span>
                  <span class="arrow-right"></span>
                </li>,
              ],
          )}
        </ul>
      </Host>
    );
  }
}
